import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';

interface ProtectedLayoutProps {
  children: React.ReactNode;
  showNavigation?: boolean;
}

// Check if running in Electron
const isElectron = Boolean(window.electronAPI);

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children, showNavigation = true }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {showNavigation && <Navigation />}
      <main className="container mx-auto px-4 py-8 flex-grow">
        {children}
      </main>
      {/* Only show footer on web, not in Electron */}
      {!isElectron && <Footer />}
    </div>
  );
};

export default ProtectedLayout;
